import {Type} from 'class-transformer';
import {BaseIdModel} from 'common-shared';
import {ExpressionModel} from "../../common/expression.model";

export class CostPriceComponentPriceModel extends BaseIdModel {
  @Type(() => ExpressionModel)
  PriceExpression: ExpressionModel;
  Price?: number;
  CostPriceComponentId: string;
  @Type(() => Date)
  FromDate?: Date;
  @Type(() => Date)
  ToDate?: Date;

  constructor() {
    super();
    this.PriceExpression = new ExpressionModel();
  }

  static CreateDefault(init?: Partial<CostPriceComponentPriceModel>) {
    return Object.assign(new CostPriceComponentPriceModel(), {} as CostPriceComponentPriceModel, init);
  }
}

export class CostPriceComponentPriceListModel extends CostPriceComponentPriceModel {
  ItemId: string;
  Item: string;
  ResourceId: string;
  Resource: string;
  Component: string;
}
